import useAuthStore from '@store/authstore';
import axios from 'axios';

const logout = useAuthStore.getState().logout;

export const axiosInstanceAuth = axios.create({
    baseURL: process.env.NEXT_PUBLIC_API_AUTH,
    timeout: 60000,
    headers: { 'Content-Type': 'application/json'}
})

export const axiosInstanceTAPFIN = axios.create({
    baseURL: process.env.NEXT_PUBLIC_API_TAP_FIN,
    timeout: 60000,
    headers: { 'Content-Type': 'application/json'}
})

export const axiosInstanceVendor = axios.create({
    baseURL: process.env.NEXT_PUBLIC_API_VENDOR,
    timeout: 60000,
    headers: { 'Content-Type': 'application/json' }
})

axiosInstanceTAPFIN.interceptors.request.use(
    (config) => {
        // const fingerprint = localStorage.getItem("fingerprint")
        // config.headers['Fingerprint'] = fingerprint;

        if (process.env.NODE_ENV !== 'production') {
            // console.log('Request sent:', config);
        }

        return config;
    },
    (error) => {
        if (process.env.NODE_ENV !== 'production') {
            console.error('Request error:', error);
        }
        return Promise.reject(error);
    }
);
axiosInstanceAuth.interceptors.request.use(
    (config) => {
        const fingerprint = localStorage.getItem("fingerprint")
        config.headers['Fingerprint'] = fingerprint;

        if (process.env.NODE_ENV !== 'production') {
            // console.log('Request sent:', config);
        }

        return config;
    },
    (error) => {
        if (process.env.NODE_ENV !== 'production') {
            console.error('Request error:', error);
        }
        return Promise.reject(error);
    }
);

axiosInstanceVendor.interceptors.request.use(
    (config) => {
        const fingerprint = localStorage.getItem("fingerprint")
        config.headers['Fingerprint'] = fingerprint;

        if (process.env.NODE_ENV !== 'production') {
            // console.log('Request sent:', config);
        }

        return config;
    },
    (error) => {
        if (process.env.NODE_ENV !== 'production') {
            console.error('Request error:', error);
        }
        return Promise.reject(error);
    }
);

// perlu validasi code 401 gk selamanya karena token expired
axiosInstanceVendor.interceptors.response.use(
  (response) => {
    if (response.data?.code === 401) {
      logout(); // 🔒 Panggil logout jika unauthorized
    }
    return response;
  },
  (error) => {
    if (error.response?.data?.code === 401) {
      logout(); // Bisa juga logout dari sini jika error 401
    }
    return Promise.reject(error);
  }
);


export const httpHeader = (token: string) => {
    return { headers: { Authorization: token} };
};


export default axiosInstanceAuth;